












































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import draggable from "vuedraggable";
import PushApplicationsRowItem from "@/components/Push/Applications/PushApplicationsRowItem.vue";
import {Getter} from "vuex-class";

@Component({
  components: {PushApplicationsRowItem, draggable}
})
export default class PushApplicationsTable extends Vue {
  @Prop() applications: any;
  @Prop() filteredApplications: any;
  @Getter("pushApplications") applicationsList!: any[];

  private modelDragon: any[] = [];
  isOpen: boolean = false;

  onDeleteAction(item: any) {
    const index = this.modelDragon.findIndex(x => x.id === item.id);
    if (index !== -1) this.modelDragon.splice(index, 1);

    this.$emit('onDeleteApplication', item.name);
  }

  onSaveAction(name: string) {
    this.$emit('onAddApplication', name);
  }

  generateUniqueId(): number {
    return Date.now();
  }

  addItem() {
    this.isOpen = true;
    if (!this.modelDragon) this.modelDragon = [];
    this.modelDragon.push({ id: this.generateUniqueId(), name: null });
  }

  @Watch('applications', { immediate: true, deep: true })
  onChangeApplications(val?: any) {
    this.modelDragon = val;
  }

  @Watch('modelDragon', { immediate: false, deep: true })
  onModelDragon(val?: any) {
    this.$emit('onChangeModelDragon', val);
  }
}
